import axios from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function getSponsorJobOffersByProgram (IdProgram) {
    const URI = `${BASE_URL}/api/sponsorJobOffersByProgram/${IdProgram}`
    return axios.get(URI, { headers })
}

export { getSponsorJobOffersByProgram }